import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import configureStore from './stores';

const store = configureStore();

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render((
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  ), document.getElementById('reviews-root'));
});

if (process.env.NODE_ENV === 'development') {
  module.hot.accept();
}
